import { UserAccountStatusEnum, VerifStatusEnum } from '@/lib/enum';
import BadgeUserCertified from './BadgeUserCertified';
import { cn, isCertified } from '@/lib/utils';
import CommaSeparator from './CommaSeparator';
import { VenetianMask } from 'lucide-react';
import { getAge } from '@/functions';

export type TUsernameProps = {
  badgeSize?: number | string;
  forceDisplayBadge?: boolean;
  hideAge?: boolean;
  className?: string;
  user?: {
    accountStatus?: UserAccountStatusEnum;
    birthdate?: Date | string;
    incognito?: boolean;
    username?: string;
    verifications?: {
      id?: {
        status: VerifStatusEnum;
      };
    };
  };
};

const Username = ({ user, className, hideAge, badgeSize = 20, forceDisplayBadge = false }: TUsernameProps) => {

  if (!user?.username) {
    return <></>;
  }

  return (
    <div className='flex items-center space-x-1'>
      <p
        title={user.username}
        className={cn(
          'text-sm font-semibold truncate overflow-hidden',
          className
        )}>
        {user.username}
      </p>
      {
        (forceDisplayBadge || isCertified(user.verifications)) &&
        <span title={`L'utilisateur est certifié`}>
          <BadgeUserCertified
            forceDisplay={forceDisplayBadge}
            size={badgeSize}
            user={user} />
        </span>
      }
      {
        !hideAge &&
        user.birthdate &&
        <>
          <CommaSeparator />
          <span className={cn('text-muted-foreground/65 text-sm whitespace-nowrap', className)}>
            {getAge(user.birthdate)} ans
          </span>
        </>
      }
      {
        user.incognito &&
        <>
          <CommaSeparator />
          <span title={`Le mode incognito est actif`}>
            <VenetianMask
              className='text-purple-600'
              size={badgeSize} />
          </span>
        </>
      }
    </div>
  );

};

export default Username;
